import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import GUI from 'lil-gui'
import { TransformControls } from 'three/addons/controls/TransformControls.js'
import { RectAreaLightHelper } from 'three/examples/jsm/helpers/RectAreaLightHelper.js'

/**
 * Base
 */
// Debug
const gui = new GUI(
    {
        width: 350,
        closeFolders: true
    })
gui.close()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Lights
 */
// Ambient Light
const ambientLight = new THREE.AmbientLight()
ambientLight.color = new THREE.Color(0xffffff)
ambientLight.intensity = 1

gui.add(ambientLight,'intensity').min(0).max(3).step(0.001).name('Ambient Intensity')

scene.add(ambientLight)

// Directional Light
const directionalLight = new THREE.DirectionalLight(0x00fffc,0.5)

directionalLight.position.set(1,0.25,0)

scene.add(directionalLight)

// Hemisphere Light
const hemisphereLight =  new THREE.HemisphereLight(0xff0000,0x0000ff,0.9)

scene.add(hemisphereLight)

// Point Light
const pointLight = new THREE.PointLight(0xff9000,1.5,10,2)
pointLight.position.set(1,-0.5,1)
pointLight.lookAt(new THREE.Vector3())

scene.add(pointLight)

// RectArea Light
const rectAreaLight = new THREE.RectAreaLight(0x4e00ff,6,1,1)
rectAreaLight.position.set(-1.5,0,1.5)
rectAreaLight.lookAt(new THREE.Vector3())

scene.add(rectAreaLight)

// Spot Light
const spotLight = new THREE.SpotLight(0x78ff00,4.5,10,Math.PI*0.1,0.25,1)
spotLight.position.set(0,2,3)
scene.add(spotLight)

// Light Helpers
const hemisphereLightHelper = new THREE.HemisphereLightHelper(hemisphereLight,0.2)
scene.add(hemisphereLightHelper)

const directionalLightHelper = new THREE.DirectionalLightHelper(directionalLight,0.2)
scene.add(directionalLightHelper)

const pointLightHelper = new THREE.PointLightHelper(pointLight,0.2)
scene.add(pointLightHelper)

const spotLightHelper = new THREE.SpotLightHelper(spotLight)
scene.add(spotLightHelper)

const rectAreaLightHelper = new RectAreaLightHelper(rectAreaLight)
scene.add(rectAreaLightHelper)

// Lights transform controls
const lights = {light:pointLight}
gui
    .add(lights,'light',{point:pointLight,rect:rectAreaLight,spot:spotLight})
    .onChange((event)=>{
        console.log(event)
        transformControls.attach(event)
    })
    .name('Light Transform')


/**
 * Objects
 */
// Material
const material = new THREE.MeshStandardMaterial()
material.roughness = 0.4

// Objects
const sphere = new THREE.Mesh(
    new THREE.SphereGeometry(0.5, 32, 32),
    material
)
sphere.position.x = - 1.5

const cube = new THREE.Mesh(
    new THREE.BoxGeometry(0.75, 0.75, 0.75),
    material
)

const torus = new THREE.Mesh(
    new THREE.TorusGeometry(0.3, 0.2, 32, 64),
    material
)
torus.position.x = 1.5

const plane = new THREE.Mesh(
    new THREE.PlaneGeometry(5, 5),
    material
)
plane.rotation.x = - Math.PI * 0.5
plane.position.y = - 0.65

scene.add(sphere, cube, torus, plane)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 2 * 2.3
camera.position.y = 2 * 2.3
camera.position.z = 4 * 2.3
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

const transformControls = new TransformControls(camera,canvas)
transformControls.addEventListener( 'dragging-changed', function ( event ) {
    transformControls._gizmo.object.lookAt(new THREE.Vector3(0,0,0))
    spotLightHelper.update()
    controls.enabled = ! event.value
} )
transformControls.attach(pointLight)
const gizmo = transformControls.getHelper()
scene.add(gizmo)

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update objects
    sphere.rotation.y = 0.1 * elapsedTime
    cube.rotation.y = 0.1 * elapsedTime
    torus.rotation.y = 0.1 * elapsedTime

    sphere.rotation.x = 0.15 * elapsedTime
    cube.rotation.x = 0.15 * elapsedTime
    torus.rotation.x = 0.15 * elapsedTime

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()